<template>
  <div>
    <div v-for="(creditAssessmentLog, index) in getCreditAssessmentLogs" :key="index">
      <credit-assessment-log-summary-adapter
          class="margin-left-5 margin-right-5 margin-top-20"
          :credit-assessment-log="creditAssessmentLog">
      </credit-assessment-log-summary-adapter>
    </div>

  </div>
</template>

<script>

import EzUtils from "@/utils/EzUtils";
import { Constants, SeverityLevel } from "@/components/Constants";
import DeepClone from "lodash.clonedeep";
import CreditAssessmentLogSummaryAdapter
  from "@/components/layout/CreditAssessmentLogSummaryAdapter";

export default {
  name: "CreditAssessmentLogSummaryItem",
  components: { CreditAssessmentLogSummaryAdapter },
  props: {
    creditAssessmentLogs: {
      type: Array,
      required: true,
      default: () => ([])
    },

    sortBasedOnSeverity: {
      type: Boolean,
      default: true
    }
  },

  methods: {

    getSortedOrderBasedOnSeverity() {
      return function (creditAssessmentLog1, creditAssessmentLog2) {
        const severityDetails1 = Constants.getSeverityLevelDetails(
            creditAssessmentLog1["severity"]
        );
        const severityDetails2 = Constants.getSeverityLevelDetails(
            creditAssessmentLog2["severity"]
        );
        if (severityDetails1.severity > severityDetails2.severity) {
          return -1;
        } else if (severityDetails1.severity < severityDetails2.severity) {
          return 1;
        }
        return 0;
      }
    }
  },

  computed: {
    getCreditAssessmentLogs() {
      let creditAssessmentLogs = [];
      if (EzUtils.isNotEmpty(this.creditAssessmentLogs)) {
        creditAssessmentLogs = DeepClone(this.creditAssessmentLogs);
        if (this.sortBasedOnSeverity) {
          creditAssessmentLogs.sort(this.getSortedOrderBasedOnSeverity());
        }
      }

      return creditAssessmentLogs;
    }
  }
};
</script>

<style
    scoped
    src="../../assets/style/base.css"></style>

